// useDetermineRouteTypeAndUrl.jsx
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {routeTypes} from 'hec/components/ui/button'
import {buttonFunctions} from 'hec/components/cta'
import {formatSfraHref} from 'hec/utils/urlUtils'
import {useAppOrigin} from '~/app/hooks/use-app-origin'

type BuilderData = {
    clickFunction: string
    isInternalLink?: boolean
    pageReference?: {
        isSfraPage?: boolean
        url?: string
        scrollTargetId?: string
        [key: string]: any
    }
    externalLinkReference?: {
        url?: string
        [key: string]: any
    }
    [key: string]: any
}

/* This function relies currently on a Builder Page Reference */
/* TODO: Headless debt: Should be rebuilt to work agnostic of CMS, with it's own input model */
export const useDetermineRouteTypeAndUrl = ({
    clickFunction,
    isInternalLink,
    pageReference,
    externalLinkReference
}: BuilderData) => {
    const config = getConfig()
    const threeLetter = config.app.threeLetter
    const appOrigin = useAppOrigin() ?? ''

    switch (clickFunction) {
        case buttonFunctions.linkToElement:
            return {
                routeType: routeTypes.ELEMENT,
                url: `#${pageReference?.scrollTargetId ?? ''}`
            }
        case buttonFunctions.linkToPage:
            if (isInternalLink) {
                const isSfra = pageReference?.isSfraPage
                const routeType = isSfra ? routeTypes.SFRA : routeTypes.INTERNAL
                if (isSfra) {
                    return {
                        routeType,
                        url: formatSfraHref({
                            pageRefData: pageReference,
                            threeLetter,
                            appOrigin
                        })
                    }
                }
                return {
                    routeType,
                    url: pageReference?.url
                }
            } else {
                return {
                    routeType: routeTypes.EXTERNAL,
                    url: externalLinkReference?.url
                }
            }
        default:
            return {
                routeType: null,
                url: null
            }
    }
}
